import { createGlobalStyle } from 'styled-components';

export const GlobalOverrides = createGlobalStyle`
  .ant-select-arrow {
    color: ${({ theme }) => theme.semantic.onBackground} !important;
  }

  ::-webkit-scrollbar {
    height: 8px; /* horizontal scrollbar thickness */
  }

  ::-webkit-scrollbar-track {
    background: ${({ theme }) =>
        theme.mode === 'dark' ? '#2b2b2b' : '#f1f1f1'};
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) =>
        theme.mode === 'dark' ? '#555' : '#ccc'};
    border-radius: 4px;
    border: 2px solid
      ${({ theme }) => (theme.mode === 'dark' ? '#2b2b2b' : '#f1f1f1')};
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: ${({ theme }) =>
        theme.mode === 'dark' ? '#888' : '#aaa'};
  }

  * {
    scrollbar-width: thin;
    scrollbar-color: 
      ${({ theme }) => (theme.mode === 'dark' ? '#555 #2b2b2b' : '#ccc #f1f1f1')};
  }
`;
